import styled from 'styled-components';

export const Container = styled.div`

`;

export const ContainerBodyHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 280px;
  overflow: auto;
`;

export const TableIcons = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 15px;
`;

